import * as Parallax from 'parallax-js';

// Parallax
var scene = document.getElementById('scene');
var parallaxInstance = new Parallax(scene); 


// WEBPACK FOOTER //
// ./Static/javascript/pages/extended-hero.ts